"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { DefaultWaveLeaderboardDrop } from "./DefaultWaveLeaderboardDrop";
interface QuorumWaveLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const QuorumWaveLeaderboardDrop: React.FC<QuorumWaveLeaderboardDropProps> = t0 => {
  const $ = _c(3);
  const {
    drop,
    onDropClick
  } = t0;
  let t1;
  if ($[0] !== drop || $[1] !== onDropClick) {
    t1 = <DefaultWaveLeaderboardDrop drop={drop} onDropClick={onDropClick} contentPresentation="quorumCompact" />;
    $[0] = drop;
    $[1] = onDropClick;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};